<p>
	As far as I know, there have been no debates in parliament about AI safety so far. I would like to
	ask you to consider proposing a session about this urgent topic.
</p>
